(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beauty-offers"] && !Shopify.designMode) return;
  try {
    
  function bindBeautyOffers(root) {
    if (root.dataset.beautyOffersReady === 'true') return;
    root.dataset.beautyOffersReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide-index]'));
    var slideCount = slides.length;
    if (slideCount < 1) return;

    /**
     * @param {HTMLElement} el
     * @returns {HTMLElement | null}
     */
    function nearestRoot(el) {
      return el && el.closest ? el.closest('.section-beauty-offers') : null;
    }

    var active = slides.findIndex(function (s) {
      return !s.classList.contains('section-beauty-offers__slide--hidden');
    });
    if (active < 0) active = 0;

    var counters = Array.prototype.slice.call(root.querySelectorAll('[data-counter-current]'));
    var progressInners = Array.prototype.slice.call(root.querySelectorAll('[data-progress-inner]'));

    function applyProgress() {
      var pct = ((active + 1) / slideCount) * 100;
      progressInners.forEach(function (el) {
        el.style.width = pct + '%';
      });
    }

    function setActive(index) {
      var i = ((index % slideCount) + slideCount) % slideCount;

      slides.forEach(function (slide, idx) {
        if (idx === i) slide.classList.remove('section-beauty-offers__slide--hidden');
        else slide.classList.add('section-beauty-offers__slide--hidden');
      });

      active = i;
      var shown = active + 1;
      counters.forEach(function (el) {
        el.textContent = String(shown);
      });
      applyProgress();
    }

    root.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-action]');
      if (!btn || nearestRoot(btn) !== root) return;
      var action = btn.getAttribute('data-action');
      if (action === 'beauty-prev') setActive(active - 1);
      else if (action === 'beauty-next') setActive(active + 1);
    });

    var sx = 0;
    var sy = 0;

    root.addEventListener(
      'touchstart',
      function (ev) {
        var t = ev.touches[0];
        if (!t) return;
        sx = t.clientX;
        sy = t.clientY;
      },
      { passive: true }
    );

    root.addEventListener(
      'touchend',
      function (ev) {
        var t = ev.changedTouches[0];
        if (!t) return;
        var dx = t.clientX - sx;
        var dy = t.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) setActive(active + 1);
          else setActive(active - 1);
        }
      },
      { passive: true }
    );

    setActive(active);
  }

  function initBeautyOffersRoots() {
    var roots = document.querySelectorAll('.section.section-beauty-offers');
    for (var r = 0; r < roots.length; r++) {
      bindBeautyOffers(roots[r]);
    }
  }

  document.addEventListener('DOMContentLoaded', initBeautyOffersRoots);
  document.addEventListener('shopify:section:load', initBeautyOffersRoots);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-customer-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initReviews(scope) {
    if (!scope || scope.dataset.epReviewsBound === 'true') return;

    var shell = scope.querySelector('.section-ep-customer-reviews__shell');
    var list = scope.querySelector('.section-ep-customer-reviews__list');
    var fill = scope.querySelector('.section-ep-customer-reviews__progress-fill');
    var prev = scope.querySelector('.section-ep-customer-reviews__controls .left');
    var next = scope.querySelector('.section-ep-customer-reviews__controls .right');
    if (!list || !list.children.length) return;

    // How many cards share the row at this width, taken from CSS rather than
    // measured so it stays exact even when the cards overrun the track.
    function perView() {
      var value = parseFloat(getComputedStyle(shell || list).getPropertyValue('--ep-reviews-per-view'));
      return isFinite(value) && value >= 1 ? Math.round(value) : 1;
    }

    // Distance from one card's leading edge to the next -- card width plus the
    // gap -- read from the DOM so it stays correct as the per-view count steps.
    function step() {
      var items = list.children;
      if (items.length < 2) return items[0].getBoundingClientRect().width;
      return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
    }

    // Once the last card is on screen there is nothing further to reveal, so
    // that is the end of the run even if a few pixels of scroll range remain.
    function lastIndex() {
      return Math.max(0, list.children.length - perView());
    }

    function currentIndex() {
      var distance = step();
      if (distance <= 0) return 0;
      return Math.min(lastIndex(), Math.max(0, Math.round(list.scrollLeft / distance)));
    }

    function setIndicator(index) {
      if (!fill) return;
      var total = list.children.length;
      var pct = total > 0 ? ((index + 1) * 100) / total : 0;
      fill.style.width = Math.min(100, pct) + '%';
    }

    function update() {
      setIndicator(currentIndex());
    }

    var animation = null;

    function animateTo(target) {
      var start = list.scrollLeft;
      var delta = target - start;
      if (Math.abs(delta) < 1) return;

      if (animation) cancelAnimationFrame(animation);

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || typeof requestAnimationFrame !== 'function' || document.hidden) {
        list.scrollLeft = target;
        update();
        return;
      }

      // Mandatory snapping re-snaps the container every time the offset changes,
      // so each animation frame gets pulled to the nearest snap point and the
      // movement stutters. Suspend it for the duration and restore it on
      // landing; a finger swipe is unaffected either way.
      list.style.scrollSnapType = 'none';

      var duration = 320;
      var startedAt = null;

      function frame(now) {
        if (startedAt === null) startedAt = now;
        var progress = Math.min(1, (now - startedAt) / duration);
        var eased = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        list.scrollLeft = start + delta * eased;

        if (progress < 1) {
          animation = requestAnimationFrame(frame);
        } else {
          animation = null;
          list.scrollLeft = target;
          list.style.scrollSnapType = '';
          update();
        }
      }

      animation = requestAnimationFrame(frame);
    }

    // Move a whole card, wrapping at either end. Counting in cards rather than
    // pixels makes the wrap fire as soon as the last card is showing instead of
    // crawling the final few pixels of scroll range.
    function go(direction) {
      var last = lastIndex();
      var target = currentIndex() + direction;

      if (target > last) {
        target = 0;
      } else if (target < 0) {
        target = last;
      }

      setIndicator(target);

      var max = list.scrollWidth - list.clientWidth;
      animateTo(Math.max(0, Math.min(max, target * step())));
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    list.addEventListener('scroll', function () {
      if (animation === null) update();
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    scope.dataset.epReviewsBound = 'true';
  }

  function boot() {
    document.querySelectorAll('.section-ep-customer-reviews').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ep-latest-in-beauty"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initLatestInBeauty(scope) {
    if (!scope || scope.dataset.epBlogBound === 'true') return;

    var shell = scope.querySelector('.section-ep-latest-in-beauty__shell');
    var list = scope.querySelector('.section-ep-latest-in-beauty__list');
    var fill = scope.querySelector('.section-ep-latest-in-beauty__progress-fill');
    var current = scope.querySelector('.section-ep-latest-in-beauty__current');
    var prev = scope.querySelector('.section-ep-latest-in-beauty__counter .left');
    var next = scope.querySelector('.section-ep-latest-in-beauty__counter .right');
    if (!list || !list.children.length) return;

    // How many cards share the row at this width. Read from CSS rather than
    // measured, because the cards deliberately overrun the track slightly and a
    // measurement would round that down to one fewer than is actually shown.
    function perView() {
      var value = parseFloat(getComputedStyle(shell || list).getPropertyValue('--ep-blog-per-view'));
      return isFinite(value) && value >= 1 ? Math.round(value) : 1;
    }

    // Card-to-card distance, read from the DOM so it follows the tier.
    function step() {
      var items = list.children;
      if (items.length < 2) return items[0].getBoundingClientRect().width;
      return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
    }

    // The last position worth stopping at: once the final card is on screen
    // there is nothing further to reveal, so that is the end of the run even
    // though a few pixels of scroll range remain.
    function lastIndex() {
      return Math.max(0, list.children.length - perView());
    }

    function currentIndex() {
      var distance = step();
      if (distance <= 0) return 0;
      return Math.min(lastIndex(), Math.max(0, Math.round(list.scrollLeft / distance)));
    }

    function setIndicator(index) {
      var total = list.children.length;
      if (current) current.textContent = index + 1;
      if (fill) {
        var pct = total > 0 ? ((index + 1) * 100) / total : 0;
        fill.style.width = Math.min(100, pct) + '%';
      }
    }

    function update() {
      setIndicator(currentIndex());
    }

    var animation = null;

    function animateTo(target) {
      var start = list.scrollLeft;
      var delta = target - start;
      if (Math.abs(delta) < 1) return;

      if (animation) cancelAnimationFrame(animation);

      // Nothing to animate with when motion is reduced, the API is missing, or
      // the page is hidden -- a hidden document gets no frames, so easing would
      // never advance and the arrow would look dead.
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || typeof requestAnimationFrame !== 'function' || document.hidden) {
        list.scrollLeft = target;
        update();
        return;
      }

      // Mandatory snapping re-snaps the container every time the offset changes,
      // so each animation frame gets pulled to the nearest snap point and the
      // movement stutters instead of gliding. Suspend snapping for the duration
      // and restore it once we land -- a finger swipe is untouched by this,
      // which is why swiping already felt smooth while the buttons did not.
      list.style.scrollSnapType = 'none';

      var duration = 320;
      var startedAt = null;

      function frame(now) {
        if (startedAt === null) startedAt = now;
        var progress = Math.min(1, (now - startedAt) / duration);
        var eased = progress < 0.5
          ? 2 * progress * progress
          : 1 - Math.pow(-2 * progress + 2, 2) / 2;

        list.scrollLeft = start + delta * eased;

        if (progress < 1) {
          animation = requestAnimationFrame(frame);
        } else {
          animation = null;
          list.scrollLeft = target;
          list.style.scrollSnapType = '';
          update();
        }
      }

      animation = requestAnimationFrame(frame);
    }

    // Move a whole card, wrapping at either end the way the live carousel does.
    // Counting in cards rather than pixels is what makes the wrap fire as soon
    // as the last card is showing, instead of crawling the final few pixels.
    function go(direction) {
      var last = lastIndex();
      var target = currentIndex() + direction;

      if (target > last) {
        target = 0;
      } else if (target < 0) {
        target = last;
      }

      setIndicator(target);

      var max = list.scrollWidth - list.clientWidth;
      animateTo(Math.max(0, Math.min(max, target * step())));
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    list.addEventListener('scroll', function () {
      if (animation === null) update();
    }, { passive: true });
    window.addEventListener('resize', update);
    update();

    scope.dataset.epBlogBound = 'true';
  }

  function boot() {
    document.querySelectorAll('.section-ep-latest-in-beauty').forEach(initLatestInBeauty);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flying-off-the-shelves"] && !Shopify.designMode) return;
  try {
    
(function () {
  function bindFlyingOffTheShelvesHeaderControls(sectionScope) {
    if (!sectionScope || sectionScope.dataset.flyingOffTheShelvesNavBound === 'true') return;

    var slideshow = sectionScope.querySelector('slideshow-component.flying-off-the-shelves-products-slideshow');
    var leftBtn = sectionScope.querySelector('.flying-off-the-shelves-top-heading-controls button.left');
    var rightBtn = sectionScope.querySelector('.flying-off-the-shelves-top-heading-controls button.right');

    if (!slideshow || !leftBtn || !rightBtn) return;

    leftBtn.addEventListener('click', function (event) {
      slideshow.previous(event);
    });
    rightBtn.addEventListener('click', function (event) {
      slideshow.next(event);
    });

    sectionScope.dataset.flyingOffTheShelvesNavBound = 'true';
  }

  function upgradeThenBind(sectionScope) {
    if (!sectionScope) return;

    if (typeof customElements !== 'undefined' && customElements.whenDefined) {
      customElements.whenDefined('slideshow-component').then(function () {
        requestAnimationFrame(function () {
          bindFlyingOffTheShelvesHeaderControls(sectionScope);
        });
      });
      return;
    }

    bindFlyingOffTheShelvesHeaderControls(sectionScope);
  }

  function initFlyingOffTheShelvesSections(scope) {
    var root = scope || document;
    root.querySelectorAll('.flying-off-the-shelves').forEach(upgradeThenBind);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initFlyingOffTheShelvesSections();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initFlyingOffTheShelvesSections(event.target || document);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
